/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import BankList from "./BankList";
import TagClientMappingList from "./TagClientMappingList";
import queryString from "query-string";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { permissionCheck } from "../../../utils/permission";
import BankAccountByUseConfirmList from "./BankListByUseConfirm";

const FundsAccountDetail = (props) => {
  const { permissions } = useSelector(
    (store) => ({
      permissions: store.Profile.permissions,
    }),
  );
  const history = useHistory();
  const [activeTab, setActiveTab] = useState('bank-trans');
  const [targetPermission, setTargetPermission] = useState(null);
  const [scrapingPermission, setScrapingPermission] = useState(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'FUND_BANK_HISTORY');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "FUND_BANK_HISTORY");
      }
      const scrapingPermission = permissions.find(p => p.code === 'FINANCE_SCRAPING');
      setScrapingPermission(scrapingPermission);
    }
  }, [permissions]);

  const _setActiveTab = (value) => {
    history.push(`/funds/accout-detail?tab=${value}`);
  };

  const tabList = [
    {
      label: "은행 입출금 내역",
      action: _setActiveTab,
      value: 'bank-trans'
    },
    {
      label: "거래처별 적요 매핑내역",
      action: _setActiveTab,
      value: 'client-mapping'
    },

    {
      label: "내역확인 요청목록",
      action: _setActiveTab,
      value: 'use-confirm'
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  return (
    !isEmpty(targetPermission) && (
      <>
        {activeTab === 'bank-trans' && (
          <BankList
            history={history}
            permission={targetPermission}
            tabList={tabList}
            activeTab={activeTab}
            scrapingPermission={scrapingPermission}
          />
        )}
        {activeTab === 'client-mapping' && (
          <TagClientMappingList
            permission={targetPermission}
            tabList={tabList}
            activeTab={activeTab}
          />
        )}

        {activeTab === 'use-confirm' && (
          <BankAccountByUseConfirmList
            history={history}
            permission={targetPermission}
            tabList={tabList}
            activeTab={activeTab}
          />
        )}
      </>
    ));
};

export default FundsAccountDetail;
